import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isEqual } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { FIELD_LENGTH, InputText, ValidationService } from '@sm360/widget-commons-forms';

import GroupResponse from 'login/services/GroupResponseService/GroupResponseService.js';

import CONSTANT from 'login/constants/constant.js';

class PasswordGroup extends React.Component {
    constructor(props) {
        super(props);

        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
        this.sendResponse = this.sendResponse.bind(this);

        this.fieldRequired = true;

        this.state = {
            password: props.value,
            passwordConfirmation: props.value,
            passwordValidation: !isEmpty(props.value),
            confirmPasswordValidation: !isEmpty(props.value),
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (isEqual(this.props, nextProps) && isEqual(this.state, nextState)) {
            return false;
        }

        return true;
    }

    handlePasswordChange(value) {
        const validation = ValidationService.validatePassword(value);

        this.setState(
            {
                password: value,
                passwordValidation: validation,
            },
            () => {
                this.handleConfirmPasswordChange(validation);
            }
        );
    }

    handleConfirmPasswordChange(value) {
        const validation = ValidationService.validatePassword(value) && isEqual(this.state.password, value);

        this.setState(
            {
                passwordConfirmation: value,
                confirmPasswordValidation: validation,
            },
            () => {
                this.sendResponse();
            }
        );
    }

    sendResponse() {
        const arePasswordValid = this.state.passwordValidation && this.state.confirmPasswordValidation;
        const groupResponse = GroupResponse.createResponse(
            arePasswordValid,
            this.state.password,
            CONSTANT.ERRORS.ACCOUNT.INVALID_PASSWORD,
            LocaleService.t('LOGIN.PASSWORD_MIN')
        );

        this.props.valueChange(groupResponse);
    }

    render() {
        const { classNames } = this.props;
        classNames.push('styled-placeholder');
        return (
            <div className="PasswordInputs">
                <div>
                    <InputText
                        type="password"
                        isRequired={this.fieldRequired}
                        isValid={this.state.passwordValidation}
                        label={this.props.passwordLabel}
                        name="password"
                        valueChange={this.handlePasswordChange}
                        value={this.state.password}
                        onFocus={this.props.onFocus}
                        minLength={FIELD_LENGTH.PASSWORD_MIN}
                        maxLength={FIELD_LENGTH.PASSWORD_MAX}
                        classNames={classNames}
                        dataTest={this.props.dataTestPrefix ? `${this.props.dataTestPrefix}.password` : ''}
                    />
                </div>

                <div>
                    <InputText
                        type="password"
                        isRequired={this.fieldRequired}
                        isValid={this.state.confirmPasswordValidation}
                        label={this.props.confirmPasswordLabel}
                        name="passwordConfirmation"
                        valueChange={this.handleConfirmPasswordChange}
                        value={this.state.confirmPassword}
                        onFocus={this.props.onFocus}
                        minLength={FIELD_LENGTH.PASSWORD_MIN}
                        maxLength={FIELD_LENGTH.PASSWORD_MAX}
                        classNames={classNames}
                        dataTest={this.props.dataTestPrefix ? `${this.props.dataTestPrefix}.password-confirmation` : ''}
                    />
                </div>
            </div>
        );
    }
}

PasswordGroup.defaultProps = {
    dataTestPrefix: '',
    classNames: [],
};

PasswordGroup.propTypes = {
    value: PropTypes.string.isRequired,
    passwordLabel: PropTypes.string.isRequired,
    confirmPasswordLabel: PropTypes.string.isRequired,
    classNames: PropTypes.arrayOf(PropTypes.string),
    valueChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    dataTestPrefix: PropTypes.string,
};

PasswordGroup.displayName = 'PasswordGroup';

export default PasswordGroup;



// WEBPACK FOOTER //
// ./src/components/Library/PasswordGroup/PasswordGroup.jsx